var map = {
	"./LogoOficial.png": 155,
	"./blender.png": 1052,
	"./clear.png": 1053,
	"./clear.svg": 449,
	"./coffee-maker.png": 1054,
	"./fridge.png": 1055,
	"./garbage.png": 450,
	"./hair-dryer.png": 1056,
	"./iron.png": 1057,
	"./logout.svg": 1058,
	"./manual.png": 1059,
	"./microwave-oven.png": 1060,
	"./oven.png": 1061,
	"./printer.png": 451,
	"./television.png": 1062,
	"./toaster.png": 1063,
	"./vacuum-cleaner.png": 1064,
	"./washing-machine.png": 1065
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1051;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img nonrecursive \.(png|jpe?g|svg)$
// module id = 1051
// module chunks = 0